import { defineRule } from 'vee-validate'

const phone = () => {
  defineRule<string, any[]>('phone', (value, _target, _ctx: any) => {
    return testPhone(value)
  })
}

export default phone
